import React from 'react';
import CommentPage from '../comment-page/index.tsx';

/* MobileIdentifierCommentPage is a temporary component to call CommentPage,
as cshtml cannot render CommentPage with HOC at the moment */
const MobileIdentifierCommentPage = function MobileIdentifierCommentPage(props) {
    return (
        <CommentPage {...props} />
    );
};

export default MobileIdentifierCommentPage;
